module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/is-object.js
// module id = 3
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35